export default __webpack_public_path__ + "static/media/Pahalgam4.e266bdb9.jpg";